module.exports = __webpack_public_path__ + "fonts/avenir/2cac77ec-9bc0-4ee7-87e4-27650190744f.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/2cac77ec-9bc0-4ee7-87e4-27650190744f.woff
// module id = 41
// module chunks = 0